import { useContext, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import "./_style.scss";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkExpandableList from "../../components/atoms/TkExpandableList";
import { fakeTableList, registrationTargetStaff, schema } from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import {
  getDate57DaysLater,
  getOneYearDate,
} from "../../utils/TkChildcareLeaveDate";
import {
  checkBirthdayLaterThanRetireDate,
  checkDoubleChildcareLeave,
  checkEndDateBeforeBirthday,
  checkEndDateBeforeStartDate,
  checkEndDateLaterThanRetireDate,
  checkFutureBirthDate,
  checkHasPapaMamaPlusEndDateOneYearTwoMonthsLaterAfterBirthday,
  checkHasReasonEndDateTwoYearsLaterAfterBirthday,
  checkNoReasonPapaMamaPlusNotSelectedOneYearAfterBirthday,
  checkOverlapPeriodWithOtherChild,
  checkPapaChildcareLeaveExceedsEightWeeksFromBirthday,
  checkSameChildPapaChildcareLeaveExceedsForWeeks,
  checkSameChildPapaChildcareLeaveThreeOrMoreTimes,
  checkStartDateBeforeContractDate,
  checkStartDateEarlierThanFiftySevenDaysFromBirthday,
  requiredCheckError,
} from "./hooks/useHooks";
import { httpAPI_STA004 } from "./api/request";
import {
  IAPI_STA004_Response,
  WorkingDayNumList,
} from "../../type/apiType/IAPI_STA004";
import { PapaMamaPlus, SexFlug } from "../../assets/data/Constants";
import dayjs from "dayjs";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import _ from "lodash";

/**
 * SCRC060101 育児休業情報登録
 * 育児休業情報を登録する。
 * @return SCRC060101
 */
const SCRC060101 = (): JSX.Element => {
  const location = useLocation();
  const locationState = location.state;
  const navigate = useNavigate();
  const [childcareLeaveInfoList, setChildcareLeaveInfoList] = useState(
    Array.from({ length: 8 })
      .fill(_.cloneDeep(fakeTableList))
      .map((item, index) => {
        return (item as ITkFakeTableLineProps[]).map((obj) => ({
          ...obj,
          keyword: obj.keyword! + index,
        }));
      })
  );
  const [index, setIndex] = useState<number>(childcareLeaveInfoList.length);
  const [birthday, setBirthday] = useState<string>();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const [staffNameKanji, setStaffNameKanji] = useState<string>("");
  const [sex, setSex] = useState<string>();
  const [numberOfData, setNumberOfData] = useState<any>();
  const [papaMamaPlusValue, setPapaMamaPlusValue] = useState<string[]>(
    Array.from({ length: 8 }, () => "")
  );
  const [needInputCheck, setNeedInputCheck] = useState<boolean[]>(
    Array.from({ length: 8 }, () => false)
  );
  const [validationSchema, setValidationSchema] = useState<any>(schema);
  const [updateDateTime, setUpdateDateTime] = useState<any>();
  const [retireDate, setRetireDate] = useState<any>();
  // 出生日に入力したかどうか(入力後→false)
  const birthdayupdateFlags = useRef<Set<string>>(new Set());

  const [workingDayNumList, setWorkingDayNumList] = useState<
    WorkingDayNumList[]
  >([]);
  const apiRes = useRef<IAPI_STA004_Response>({});
  // 認証情報.ユーザタイプ
  const userType = state?.authInfo?.userType;
  // ユーザタイプが機構
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  // 共済契約者番号
  const contractorNo = isUserTypeKiko
    ? businessState?.common?.contractorNo
    : state?.authInfo?.contractorNo;
  // 職員番号（画面間パラメータ）
  const [staffNo, setStaffNo] = useState<any>("");
  const businessType = businessState.common?.businessType
    ?.toLowerCase()
    .replace("-", "_") as keyof typeof businessState;
  const businessContext = businessState[businessType];
  const isReadOnly =
    !!businessContext?.registrationProcedureInfo
      ?.bContractorNoForChildcareLeave;

  const [inputDataList, setInputDataList] = useState<any[]>([]);
  const [openWarning, setOpenWarning] = useState(false);
  const filterDataListRef = useRef<any>([]);

  // 初期化
  const handleInit = async () => {
    if (!businessState.childcareLeave) {
      try {
        let resArr = childcareLeaveInfoList;
        // 育休情報　登録表示APIを呼び出す
        const res = await httpAPI_STA004({
          contractorNo: isReadOnly
            ? businessContext?.registrationProcedureInfo
                ?.bContractorNoForChildcareLeave
            : contractorNo,
          staffNo: isReadOnly
            ? businessContext?.registrationProcedureInfo
                ?.bStaffNoForChildcareLeave
            : locationState?.staffNo,
          applyId: businessContext?.applyId,
        });

        // API呼び出しの結果、正常終了した場合、画面描画
        if (res.resultCd === "I0000") {
          apiRes.current = res;
          setWorkingDayNumList(res.workingDayNumList || []);
          setStaffNo(locationState?.staffNo);
          setStaffNameKanji(res.staffNameKanji || "");
          // 退職（予定）日
          setRetireDate(res.retireDate);

          setSex(res.sex);
          setNumberOfData(res["childcareLeaveList"]?.length || 0);
          setNeedInputCheck(
            Array.from(
              { length: 8 },
              (_, index) => index < (res["childcareLeaveList"]?.length || 0)
            )
          );
          setUpdateDateTime(res.updateDateTime);
          res["childcareLeaveList"]?.forEach(
            (childcareLeave: { [key: string]: any }, index: number) => {
              for (let i in childcareLeave) {
                const targetResArr = resArr[
                  childcareLeave["childcareLeaveSerialNo"] - 1
                ] as ITkFakeTableLineProps[];
                let targetObj = targetResArr.find(
                  (item) => item.keyword === i + index
                )!;

                if (i === "papaChildcareLeaveFlg") {
                  targetObj.setDefaultValue =
                    childcareLeave["papaChildcareLeaveFlg"] === "1"
                      ? ["有"]
                      : [];
                } else {
                  targetObj && (targetObj.setDefaultValue = childcareLeave[i]);
                }

                if (i === "papaMamaPlus") {
                  if (childcareLeave["papaMamaPlus"] === "1") {
                    const halfyearExtensionReason = targetResArr.find(
                      (item) =>
                        item.keyword === "halfyearExtensionReason" + index
                    );
                    halfyearExtensionReason &&
                      (halfyearExtensionReason.disabled = true);
                  }
                }
              }
            }
          );

          // 継続異動、経営移管等の場合は非活性にする。
          resArr.forEach((p) =>
            p.forEach((c) => {
              if (c.checkBoxList) {
                c.checkBoxList[0].disabled = isReadOnly;
              }
              c.disabled = isReadOnly;
            })
          );

          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setStaffNo(locationState?.staffNo);
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }

        setChildcareLeaveInfoList([...resArr]);
      } catch (error) {
        navigate("/error");
      }
    } else {
      let resArr = childcareLeaveInfoList;
      const childcareLeave = businessState?.childcareLeave;
      setRetireDate(childcareLeave.childcareLeaveRegistrationInfo?.retireDate);
      setWorkingDayNumList(
        childcareLeave?.childcareLeaveRegistrationInfo?.childcareActiveListList!
      );
      setStaffNo(childcareLeave.staffNo);
      setStaffNameKanji(
        childcareLeave.childcareLeaveRegistrationInfo?.staffName!
      );
      setSex(childcareLeave.childcareLeaveRegistrationInfo?.sex!);
      setNumberOfData(
        childcareLeave?.childcareLeaveRegistrationInfo?.childcareLeaveInfoList!
          .length
      );
      setNeedInputCheck(
        Array.from(
          { length: 8 },
          (_, index) =>
            index <
            childcareLeave?.childcareLeaveRegistrationInfo
              ?.childcareLeaveInfoList!.length!
        )
      );
      setUpdateDateTime(
        childcareLeave?.childcareLeaveRegistrationInfo?.updateDateTime!
      );
      childcareLeave?.childcareLeaveRegistrationInfo?.childcareLeaveInfoList!.forEach(
        (childcareLeave: { [key: string]: any }, index: number) => {
          for (let i in childcareLeave) {
            const targetResArr = resArr[
              childcareLeave["childcareLeaveSerialNo"] - 1
            ] as ITkFakeTableLineProps[];
            let targetObj = targetResArr.find(
              (item) => item.keyword === i + index
            )!;

            if (i === "papaChildcareLeaveFlg") {
              targetObj.setDefaultValue =
                childcareLeave["papaChildcareLeaveFlg"] === "1" ? ["有"] : [];
            } else {
              targetObj && (targetObj.setDefaultValue = childcareLeave[i]);
            }

            if (i === "papaMamaPlus") {
              if (childcareLeave["papaMamaPlus"] === "1") {
                targetResArr.find(
                  (item) => item.keyword === "halfyearExtensionReason" + index
                )!.disabled = true;
              }
            }
          }
        }
      );
      setChildcareLeaveInfoList([...resArr]);
    }
  };

  useEffect(() => {
    let resArr = childcareLeaveInfoList;
    resArr.forEach((childcareLeaveInfo, index) => {
      // 出生日 カレンダー 入力 処理
      let birthday = childcareLeaveInfo.find(
        (item) => item.keyword === "birthday" + index
      )!;
      birthday.onGetInputValue = (() => {
        let previousValue = "";

        return (e: any, isDefault: any) => {
          const newValue = e.target.value;

          if (isDefault) {
            previousValue = dayjs(newValue).format("YYYY/MM/DD");
            return;
          }

          if (newValue === "Invalid Date") {
            return;
          }
          const year = parseInt(newValue?.slice(0, 4), 10);
          if (year < 1900) {
            return;
          }

          if (previousValue === newValue) {
            return;
          }
          previousValue = newValue;

          setIndex(index);
          setBirthday(newValue);
          birthdayupdateFlags.current.add(index.toString());
        };
      })();

      // パパ・ママ育休プラス ラジオボタン 処理
      let papaMamaPlus = childcareLeaveInfo.find(
        (item) => item.keyword === "papaMamaPlus" + index
      )!;
      let halfyearExtensionReason = childcareLeaveInfo.find(
        (item) => item.keyword === "halfyearExtensionReason" + index
      )!;
      papaMamaPlus.onGetValue = (value: any) => {
        const newPapaMamaPlusValue: string[] = [...papaMamaPlusValue];
        newPapaMamaPlusValue[index] = value;
        setPapaMamaPlusValue(newPapaMamaPlusValue);
        if (value === PapaMamaPlus["無"]) {
          halfyearExtensionReason.disabled = false;
        } else {
          halfyearExtensionReason.disabled = true;
          halfyearExtensionReason.setDefaultValue = "";
        }
      };
      halfyearExtensionReason.onGetValue = (value: any) => {
        halfyearExtensionReason.setDefaultValue = value;
      };
    });

    setChildcareLeaveInfoList([...resArr]);
    setIndex(childcareLeaveInfoList.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 出生日 カレンダー 入力 処理
  useEffect(() => {
    if (!birthday) return;
    if (birthdayupdateFlags.current.has(index.toString())) {
      // defaultBirthdayFlg(初期値にAPIもしくは持回りからの出生日の設定がない場合)→自動計算をする
      if (index === childcareLeaveInfoList.length) return;
      let startDate = childcareLeaveInfoList[index].find(
        (item) => item.keyword === "startDate" + index
      )!;
      let endDate = childcareLeaveInfoList[index].find(
        (item) => item.keyword === "endDate" + index
      )!;
      if (sex === SexFlug["女"]) {
        startDate.setDefaultValue = getDate57DaysLater(birthday);
      } else {
        startDate.setDefaultValue = birthday;
      }
      endDate.setDefaultValue = getOneYearDate(birthday);
      setIndex(childcareLeaveInfoList.length);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthday, index]);

  // バリデーション設定
  useEffect(() => {
    const schemaResult: {
      [key: string]: {
        [key: string]: any;
      };
    } = {};
    needInputCheck.forEach((value, index) => {
      if (value) {
        schemaResult[`birthday${index}`] = schema["birthday"];
        schemaResult[`startDate${index}`] = schema["startDate"];
        schemaResult[`endDate${index}`] = schema["endDate"];
        schemaResult[`papaMamaPlus${index}`] = schema["papaMamaPlus"];
      }
    });
    setValidationSchema(schemaResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needInputCheck]);

  // 業務チェック
  const businessCheck = (inputDataList: any[]): boolean => {
    // 出生日、育児休業開始日、育児休業終了（予定）日が必須チェック
    if (requiredCheckError(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0043E",
      });
      return false;
    }

    // 出生日は退職（予定）日よりも後の日付チェック
    if (
      retireDate &&
      checkBirthdayLaterThanRetireDate(inputDataList, retireDate)
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0017E",
      });
      return false;
    }

    // 育児休業終了（予定）日は退職（予定）日よりも後の日付チェック
    if (
      retireDate &&
      checkEndDateLaterThanRetireDate(inputDataList, retireDate)
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0018E",
      });
      return false;
    }

    // 未来の出生日チェック
    if (checkFutureBirthDate(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0019E",
      });
      return false;
    }

    // 持回情報.育休情報.加入年月日がある場合
    const isStateHaveJoinDate =
      businessState?.childcareLeave?.childcareLeaveRegistrationInfo?.joinDate;

    // 育児休業開始日は加入日よりも前チェック
    if (
      checkStartDateBeforeContractDate(
        inputDataList,
        isStateHaveJoinDate ? isStateHaveJoinDate : apiRes.current.joinDate
      )
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0020E",
      });
      return false;
    }

    // 半年延長の理由が「無」で、かつパパママ育休プラスが未選択の場合に、育児休業終了（予定）日が出生日の1年後以降の日付チェック
    if (
      checkNoReasonPapaMamaPlusNotSelectedOneYearAfterBirthday(inputDataList)
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0022E",
      });
      return false;
    }

    // 半年延長の理由が「有」の場合に、育児休業終了日が出生日の２年を超える日付チェック
    if (checkHasReasonEndDateTwoYearsLaterAfterBirthday(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0024E",
      });
      return false;
    }

    // パパママ育休プラスが「有」の場合に、育児休業終了（予定）日が出生日の１年２か月後を超える日付チェック
    if (
      checkHasPapaMamaPlusEndDateOneYearTwoMonthsLaterAfterBirthday(
        inputDataList
      )
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0025E",
      });
      return false;
    }

    // 同一の育児休業２重登録チェック
    if (checkDoubleChildcareLeave(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0026E",
      });
      return false;
    }

    // 同一の子について「産後パパ育休」を３回以上登録チェック
    if (checkSameChildPapaChildcareLeaveThreeOrMoreTimes(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0027E",
      });
      return false;
    }

    // 産後パパ育休は子の出生日から８週間（５６日）を超えて終了日チェック
    if (checkPapaChildcareLeaveExceedsEightWeeksFromBirthday(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0012W",
      });
      return false;
    }

    // 同一の子について「産後パパ育休」を４週間（２８日）を超えるチェック
    if (checkSameChildPapaChildcareLeaveExceedsForWeeks(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0029E",
      });
      return false;
    }

    // 女性で、育児休業開始日が出産日の「8週間後+１日」(57日)よりも前の日付で入力されているチェック
    if (
      checkStartDateEarlierThanFiftySevenDaysFromBirthday(inputDataList, sex)
    ) {
      setOpenWarning(true);
      return false;
    }

    // 第１子の育児休職期間に第２子の産休が開始されるチェック
    if (checkOverlapPeriodWithOtherChild(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0013W",
      });
      return false;
    }
    // 入出力項目.育児休業終了（予定）日 ＜ 入出力項目.出生日
    if (checkEndDateBeforeBirthday(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0115E",
      });
      return false;
    }
    // 入出力項目.育児休業終了（予定）日 ＜ 入出力項目.育児休業開始日
    if (checkEndDateBeforeStartDate(inputDataList)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0116E",
      });
      return false;
    }
    setState({
      ...state,
      errorMsgId: "",
    });
    return true;
  };

  const onCheckAndSubmit = async (data: any) => {
    const dataList = inputDataList;
    dataList.push(data);
    setInputDataList(dataList);
    if (dataList.length === 8) {
      const filteredInputDataList = dataList.map(
        (
          inputData: {
            [key: string]: any;
          },
          index
        ) => {
          return {
            childcareLeaveSerialNo: index + 1,
            birthday: inputData["birthday" + index],
            startDate: inputData["startDate" + index],
            endDate: inputData["endDate" + index],
            papaMamaPlus: inputData["papaMamaPlus" + index],
            halfyearExtensionReason:
              inputData["papaMamaPlus" + index] === "0"
                ? inputData["halfyearExtensionReason" + index]
                : undefined,
            papaChildcareLeaveFlg: inputData["papaChildcareLeaveFlg" + index]
              ?.length
              ? "1"
              : "0",
          };
        }
      );
      const filterDataList = filteredInputDataList.filter(
        (item) => !!item.birthday
      );
      filterDataListRef.current = filterDataList;
      if (businessCheck(filterDataList)) {
        // 持回情報
        setBusinessState({
          ...businessState,
          childcareLeave: {
            staffNo: staffNo,
            childcareLeaveRegistrationInfo: {
              updateDateTime: updateDateTime,
              staffName: staffNameKanji,
              sex: sex,
              joinDate:
                apiRes.current.joinDate ??
                businessState.childcareLeave?.childcareLeaveRegistrationInfo
                  ?.joinDate,
              retireDate: retireDate,
              childcareLeaveInfoList: filterDataList,
              childcareActiveListList: workingDayNumList,
            },
          },
        });
        navigate("/SCRC060102");
      } else {
        setInputDataList([]);
      }
    }
  };

  const titleArray = [
    "一回目",
    "二回目",
    "三回目",
    "四回目",
    "五回目",
    "六回目",
    "七回目",
    "八回目",
  ];

  const refs = [
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
    useRef<any>(null),
  ];

  const submitByRef = () => {
    refs.forEach((ref) => {
      ref.current.submit();
    });
  };

  // 確認ボタン　押下
  const handleSubmit = () => {
    submitByRef();
  };

  const handleOpenSubmitModal = () => {
    setOpenWarning(false);
    // 持回情報
    setBusinessState({
      ...businessState,
      childcareLeave: {
        staffNo: staffNo,
        childcareLeaveRegistrationInfo: {
          updateDateTime: updateDateTime,
          staffName: staffNameKanji,
          sex: sex,
          joinDate:
            apiRes.current.joinDate ??
            businessState.childcareLeave?.childcareLeaveRegistrationInfo
              ?.joinDate,
          retireDate: retireDate,
          childcareLeaveInfoList: filterDataListRef.current,
          childcareActiveListList: workingDayNumList,
        },
      },
    });
    navigate("/SCRC060102");
  };

  const handleCancelModal = () => {
    setOpenWarning(false);
    setInputDataList([]);
  };

  return (
    <Box className="SCRC060101" data-testid="SCRC060101PageForTest">
      <Box>{registrationTargetStaff}</Box>

      <Box className="info">{`${staffNo ?? ""}:${staffNameKanji}`}</Box>

      {!isReadOnly && (
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLC060101_01}
        </TkInfoManual>
      )}

      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}

      {[...Array(8)].map((_, index) => (
        <TkExpandableList
          title={titleArray[index]}
          key={index}
          defOpen={index <= numberOfData ? true : false}
        >
          <TkFakeTable
            ref={refs[index]}
            list={childcareLeaveInfoList[index] as ITkFakeTableLineProps[]}
            ruleSchema={validationSchema}
            onCheckAndSubmit={onCheckAndSubmit}
            showButton={false}
          />
        </TkExpandableList>
      ))}
      <Box className="SCRC060101Button">
        <TkBackButton useBackParam />
        {!isReadOnly && <TkButton onClick={handleSubmit}>確認</TkButton>}
      </Box>

      <TkMessageDialog
        open={openWarning}
        onOky={handleOpenSubmitModal}
        onCancel={handleCancelModal}
        onClose={handleCancelModal}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0002W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC060101;
